{{ 'common.application.environment-hint' | translate: { stage: stage() } }}
